module.exports = __webpack_public_path__ + "static/media/jobs_card_min.16c50650.jpg";